"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ESavePhoneStatus", {
  enumerable: true,
  get: function () {
    return _savephone.ESavePhoneStatus;
  }
});
exports.confirmPhone = confirmPhone;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _savephone = require("../types/api-models/api/profile/savephone");
const _excluded = ["subdomain"];
function confirmPhone(httpApi, parameters) {
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  return httpApi.fetch((0, _savephone.createSavePhoneModel)({
    parameters: restParameters
  }), {
    subdomain,
    bodyAsEncodeString: true,
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded']]
    }
  });
}